export function getProjectOptions({ role, project, township_group_id }) {
  if (role == 2 || role == 4 || role==6) {
    if (project == 1) {
      return [
        { value: "PICTS1", label: "PICTS1" },
        { value: "PICTS2", label: "PICTS2" },
      ];
    } else if (project == 2) {
      return [
        { value: "MDR1", label: "MDR1" },
        { value: "MDR2", label: "MDR2" },
      ];
    }
  } else {
    return [
      { value: "MDR", label: "MDR" },
      { value: "PICTS", label: "PICTS" },
      { value: "MDR1", label: "MDR1" },
      { value: "MDR2", label: "MDR2" },
      { value: "PICTS1", label: "PICTS1" },
      { value: "PICTS2", label: "PICTS2" },
    ];
  }
}
